var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.75C1 2.23122 2.23122 1 3.75 1H12.75C13.1642 1 13.5 1.33579 13.5 1.75C13.5 2.16421 13.1642 2.5 12.75 2.5H3.75C3.05964 2.5 2.5 3.05964 2.5 3.75V4H16.25C17.7688 4 19 5.23122 19 6.75V16.25C19 17.7688 17.7688 19 16.25 19H3.75C2.23122 19 1 17.7688 1 16.25V3.75ZM2.5 5.5V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H16.25C16.9404 17.5 17.5 16.9404 17.5 16.25V6.75C17.5 6.05964 16.9404 5.5 16.25 5.5H2.5ZM14.25 11C13.9739 11 13.75 11.2239 13.75 11.5C13.75 11.7761 13.9739 12 14.25 12C14.5261 12 14.75 11.7761 14.75 11.5C14.75 11.2239 14.5261 11 14.25 11ZM12.25 11.5C12.25 10.3954 13.1454 9.5 14.25 9.5C15.3546 9.5 16.25 10.3954 16.25 11.5C16.25 12.6046 15.3546 13.5 14.25 13.5C13.1454 13.5 12.25 12.6046 12.25 11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.53137a5dff75b2b4023e1618534b36e0.svg";
export { ForwardRef as ReactComponent };